import React, { useMemo } from 'react';
import "./Themes.less";

export default function Banner(props) {
    const {isDesktop, theme} = props

    const { mainText, secondaryText } = useMemo(() => {
        const getMainText = () => {
            if (!theme?.name) return 'popularne';
            return theme.name === 'Božić' ? (isDesktop ? 'popularne' : theme.name) : theme.name;
        };

        const getSecondaryText = () => {
            if (!theme?.name) return 'teme';
            return theme.name === 'Božić' ? (isDesktop ? 'teme' : theme.description) : theme.description;
        };

        return {
            mainText: getMainText(),
            secondaryText: getSecondaryText()
        };
    }, [theme, isDesktop]);

    const renderThemeBanner = () => (
        <div className={`theme-head-banner ${theme?.code || ''}`}>
            <div className="background-container">
                <div className="gradient-mask"></div>
                <div className="background-repeat-image"></div>
                <div className="background-image"></div>
            </div>
            <div className="content-container">
                <div className={`text-container${theme?.code ? ' theme' : ''}`}>
                    <div className="text">{mainText}</div>
                    <div className="text description">{secondaryText}</div>
                </div>

                <div className="image-elements">
                    <div className="img-left"></div>
                    <div className="img-center"></div>
                    <div className="img-right"></div>

                    <div className="voce img1"></div>
                    <div className="voce img2"></div>
                    <div className="voce img3"></div>
                    <div className="voce img4"></div>
                    <div className="voce img5"></div>
                    <div className="voce img6"></div>
                </div>

                <div className="image-element el-1"></div>
                <div className="image-element el-2"></div>
                <div className="image-element el-3"></div>
                <div className="image-element el-4"></div>
                <div className="image-element el-5"></div>
                <div className="image-element el-6"></div>
            </div>
        </div>
    )

    return renderThemeBanner();       
}
